module.exports = __webpack_public_path__ + "static/media/1001452DO.0e6ff646.jpg";